import styled from 'styled-components';
import { Spinner } from 'ui/spinner';
import { LocationsMap } from './LocationsMap';
import { useProfileQueryContext } from '../../../contexts/demographicInsights';

const SpinnerWrapper = styled.div`
  display: flex;
  height: 100%;
  justify-content: center;
`;

export const DemographicsLocations = () => {
  const { isProfileLoading } = useProfileQueryContext();

  if (isProfileLoading)
    return (
      <SpinnerWrapper>
        <Spinner />
      </SpinnerWrapper>
    );

  return <LocationsMap />;
};
